// @flow
import {Root} from 'modules/customerService';
import {NotFound} from 'components/NotFound';

export const customerService = [
  {
    Component: Root,
    isProtected: true,
    index: true,
    label: 'Customer Service',
  },
  {
    Component: NotFound,
    isProtected: true,
    path: '*',
  },
];
